/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Spec_ErrorInputs */



/**
* | output |
* | --- |
* | "The API description could not be stored." |
*
* @param {Integrations_Apis_Spec_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_spec_error = /** @type {((inputs?: Integrations_Apis_Spec_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Spec_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die API-Beschreibung konnte nicht gespeichert werden.")
	return /** @type {LocalizedString} */ ("The API description could not be stored.")
});